/**
 * ThemeToggle - DISABLED: Light mode only
 * Dark mode removed per Corbin's request (2026-02-18)
 */

import { useEffect } from 'react'

/**
 * Force light mode on mount — no toggle needed
 */
export function ThemeToggle() {
  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('dark')
    root.setAttribute('data-theme', 'light')
    localStorage.setItem('theme', 'light')
  }, [])

  // No UI rendered — light mode only
  return null
}

export function ThemeToggleCompact() {
  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('dark')
    root.setAttribute('data-theme', 'light')
    localStorage.setItem('theme', 'light')
  }, [])

  return null
}
